// extracted by mini-css-extract-plugin
module.exports = {"web3Header":"_locale__web3Header__CE6To"};